document.addEventListener("DOMContentLoaded", function () {

  // TreeWalker to find text nodes containing "®"
  const trademarkWalker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(textNode) {
        if (!textNode.nodeValue || !textNode.nodeValue.includes("®")) {
          return NodeFilter.FILTER_REJECT;
        }

        // Skip if inside SUP, SCRIPT, STYLE, NOSCRIPT
        let currentParent = textNode.parentElement;
        while (currentParent) {
          const tagName = currentParent.tagName;
          if (tagName === "SUP") {
            return NodeFilter.FILTER_REJECT;
          }
          currentParent = currentParent.parentElement;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    }
  );

  // Store text nodes (walker modifies live DOM)
  const trademarkTextNodes = [];
  let currentNode;
  while (currentNode = trademarkWalker.nextNode()) {
    trademarkTextNodes.push(currentNode);
  }

  // Replace plain "®" in text nodes
  trademarkTextNodes.forEach(trNode => {
    const splitParts = trNode.nodeValue.split("®");
    if (splitParts.length <= 1) return;

    const parentEl = trNode.parentNode;

    splitParts.forEach((chunk, index) => {
      if (chunk.length) {
        parentEl.insertBefore(document.createTextNode(chunk), trNode);
      }
      if (index < splitParts.length - 1) {
        const supTag = document.createElement("sup");
        supTag.textContent = "®";
        parentEl.insertBefore(supTag, trNode);
      }
    });

    parentEl.removeChild(trNode);
  });

});